import type { components } from "@/api-schema";
import { DetailTabGrid } from "@/components/detail-page/_components/tab/detail-tab-grid";
import { Briefcase, Building2, GraduationCap, MapPin, Tag, Users } from "lucide-react";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { SystemInfo } from "../../_components/system-info";
import { mergeAndFilterBranches } from "./_helpers/merge-and-filter-branches";

type User = components["schemas"]["User"];

export function OrganizationTab({ user }: { user: User }): ReactElement {
  const { t } = useTranslation(["masterdata", "common"]);
  const branches = mergeAndFilterBranches(user.mainBranch, user.branches);

  return (
    <DetailTabGrid>
      <SystemInfo
        label={t("common:Company")}
        subject="Company"
        items={user.companies}
        icon={<Building2 className="text-muted-foreground h-4 w-4" />}
      />
      <SystemInfo
        label={t("common:Brand")}
        subject="Brand"
        items={user.brands}
        icon={<Tag className="text-muted-foreground h-4 w-4" />}
      />
      <SystemInfo
        label={t("common:Branch")}
        subject="Branch"
        items={branches}
        icon={<MapPin className="text-muted-foreground h-4 w-4" />}
      />
      <SystemInfo
        label={t("common:Department")}
        subject="Department"
        items={user.departments}
        icon={<Users className="text-muted-foreground h-4 w-4" />}
      />
      <SystemInfo
        label={t("common:Occupation")}
        subject="Occupation"
        items={user.occupations}
        icon={<GraduationCap className="text-muted-foreground h-4 w-4" />}
      />
      <SystemInfo
        label={t("masterdata:Function")}
        subject="JobFunction"
        items={user.jobFunctions}
        icon={<Briefcase className="text-muted-foreground h-4 w-4" />}
      />
    </DetailTabGrid>
  );
}
